// extracted by mini-css-extract-plugin
module.exports = {"root":"UsHTa","wrapper":"_1p6uL","spinner":"YgNZO"};